import { Box, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface Benefit {
  title: string;
  description: string;
}

interface BenefitsProps {
  title?: string;
  subtitle?: string;
  benefits?: Benefit[];
}

const Benefits = ({ title, subtitle, benefits }: BenefitsProps) => { 
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const isRtl = language === "ar";
  return (
    <Box
      sx={{
        direction: isRtl ? "rtl" : "ltr",
        width: "436px",
        height: "286px",
        borderBottomWidth: "1px",
        gap: "16px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Typography
        sx={{
          width: "192px",
          height: "10px",
          fontWeight: 700,
          fontSize: "16px",
          color: "#625783",
          marginTop: "24px",
        }}
      >
        {t("Automation.benefitsForTemplate")}
      </Typography>

      {benefits ? (
        benefits.map((benefit, index) => (
          <React.Fragment key={index}>
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "12px",
                leading: "Cap height",
                lineHeight: "14.4px",
                letterSpacing: "0%",
                marginTop: "16px",
                color: "#435363",
              }}
            >
              {`${index + 1}. ${benefit.title}`}
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "12px",
                leading: "Cap height",
                lineHeight: "14.4px",
                color: "#435363",
              }}
            >
              {benefit.description}
            </Typography>
          </React.Fragment>
        ))
      ) : (
        <>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "12px",
              leading: "Cap height",
              lineHeight: "14.4px",
              letterSpacing: "0%",
              textAlign: "right",
              marginTop: "16px",
              color: "#435363",
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "12px",
              leading: "Cap height",
              lineHeight: "14.4px",
              color: "#435363",
            }}
          >
            {subtitle}
          </Typography>
        </>
      )}
    </Box>
  );
};

export default Benefits;
